import React from "react";
import { Col, Row } from 'react-bootstrap';
import Aux from '../../hoc/Aux';
import SuccessResult from './SuccessResult/SuccessResult';
import ErrorResult from './ErrorResult/ErrorResult';


const result = (props) => {
  let message = null;

  if(props.bookingSucceeded){
    message = (
      <SuccessResult
        newBtnClicked={() => props.onSuccessStartNewBtnClicked()} />
    );
  }else{
    message = (
      <ErrorResult 
        errors={props.bookingErrors}
        backBtnClicked={() => props.onErrorGoBackBtnClicked()} />
    )
  }

  return (
    <Aux>
        <Row>
          <Col xs={12}>
            {message}
          </Col>
        </Row>
    </Aux>
  );

}

export default result;